import CodeBlock from './code-block'

export { PreStyled } from './code-block.styled'
export { rehypePrism } from './utils'

export default CodeBlock
